// extracted by mini-css-extract-plugin
export default {"modal":"LlavesOrdena_modal__JUyaW","nombre":"LlavesOrdena_nombre__ZWAmM","botok":"LlavesOrdena_botok__9G-Hw","contCheckboxes":"LlavesOrdena_contCheckboxes__5aeuY"};